import PropTypes from 'prop-types';

export default PropTypes.shape({
  date: PropTypes.string,
  id: PropTypes.string.isRequired,
  mfaPolicies: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string.isRequired,
});
